<template>
  <VLayout
    :title="$t('pharmacies.title')"
    :subtitle="countryName"
    tinyFooter
  >
    <div class="text-justify">
      <span class="globalstorepharma">
        {{ $t("pharmacies.globalstorepharma") }}
      </span>
      {{ $t("pharmacies.description") }}
    </div>

    <b-container fluid class="p-0 mt-5">
      <b-row>
        <b-col cols="12" md="6">
          <b-form inline>
            <b-input
              v-model="form.pharmacy"
              :placeholder="$t('pharmacies.pharmacy_name') + '...'"
              class="w-50"
            ></b-input>
            <b-button
              variant="primary"
              class="w-25"
              @click="searchByName"
            >
              {{ $t("pharmacies.search") }}
            </b-button>
          </b-form>
        </b-col>
        <b-col cols="12" md="6" class="mt-3 mt-md-0">
          <b-form inline>
            <CountrySelect
              ref="country-select"
              :placeholder="$t('pharmacies.select_country') + '...'"
              v-model="form.country"
              :topCountry="deviceCountry"
              class="custom-select w-50 ml-md-auto"
            />
            <b-button
              variant="primary"
              class="see-button w-25 ml-4"
              @click="searchByCountry"
            >
              {{ $t("pharmacies.see_pharmacies") }}
            </b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>

    <vue-element-loading :active="loading_pharmacies" />
    <b-container v-if="pharmacies && pharmacies.length" fluid class="p-0 mt-5">
      <b-row class="d-flex justify-content-between">
        <b-col cols="12" md="6" v-for="(pharmacy, index) in pharmacies" v-bind:key="index">
          <b-row align-v="center" class="mx-0 py-4 border-bottom">
            <b-col cols="3" md="2" class="pl-0">
              <PictureFallback
                :src="pharmacy.logo"
                type="pharmacy"
                class="border p-2"
              />
            </b-col>
            <b-col cols="9" md="6">
              <div class="pharmacy-name text-uppercase">
                {{ pharmacy.public_name }}
              </div>
              <!-- No queremos mostrar esta información, de momento. La volveremos
              a mostrar cuando podamos editar/gestionar bien esa información en el BO -->
              <!-- <div class="pharmacy-email mt-2">
                <b-link :href="'mailto:' + pharmacy.email">
                  {{ pharmacy.email }}
                </b-link>
              </div> -->
            </b-col>
            <b-col cols="12" md="4" class="pr-0">
              <b-button
                variant="primary-b"
                class="see-button mx-auto mr-md-0 ml-md-auto mt-3 mt-md-0"
                @click="pharmacyDetails(pharmacy.uuid)"
              >
                {{ $t("pharmacies.see_products") }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col>
          <Pagination
            v-if="perPage < total"
            :total="total"
            :perPage="perPage"
            v-model="currentPage"
            @input="onPageChange"
            class="justify-content-center"
          />
        </b-col>
      </b-row>
    </b-container>
    <div v-else class="mt-5">
      {{ $t("pharmacies.no_results") }}
    </div>
  </VLayout>
</template>


<script>
import { mapGetters } from "vuex";
import VLayout from "@/layouts/Default";
import { CountrySelect } from "vue-country-region-select";
import { getCountryName } from "@/lib/country";
import PictureFallback from "@/components/PictureFallback";
import Pagination from "@/components/Pagination";

export default {
  name: "pharmacy-list",
  components: {
    VLayout,
    CountrySelect,
    PictureFallback,
    Pagination,
  },
  props: {
    pharmacy: {
      default: undefined,
      type: String,
    },
    country: {
      default: undefined,
      type: String,
    },
  },
  data() {
    return {
      pharmacies: undefined,
      loading_pharmacies: true,
      form: {
        pharmacy: undefined,
        country: undefined,
      },
      total: 0,
      perPage: 10,
      currentPage: 1,
    };
  },
  watch: {
    $route() {
      this.reload();
    },
  },
  created() {
    this.reload();
  },
  computed: {
    ...mapGetters("auth", ["deviceCountry"]),
    countryName() {
      if (!this.country) {
        return undefined;
      }
      return getCountryName(this.country);
    },
  },
  methods: {
    reload() {
      this.loadForm();
      this.loadBreadcrumb();
      this.loadPharmacies();
    },
    loadForm() {
      this.form.pharmacy = this.pharmacy;
      this.form.country = this.country;
    },
    loadPharmacies() {
      this.loading_pharmacies = true;
      this.$store
        .dispatch("organization/REQUEST_PHARMACIES", {
          per_page: this.perPage,
          current_page: this.currentPage,
          with_pub_prices_to_country: this.country || "all",
          pharmacy: this.pharmacy,
        })
        .then(
          response => {
            this.pharmacies = response.data.results;
            this.total = response.data.count;
            this.loading_pharmacies = false;
          },
          err => {
            this.$sentry({ capture: err });
            this.$router.push({ name: "fallback-error-page" });
            this.loading_pharmacies = false;
          }
        );
    },
    loadBreadcrumb() {
      var breadcrumb = [
        { langkey: "home.breadcrumb", route: "home" },
        { langkey: "pharmacies.title", route: this.$route.name },
      ];
      if (this.countryName) {
        breadcrumb.push({ langkey: this.countryName });
      }
      try {
        this.$store.dispatch("siteconf/CHANGE_BREADCRUMB", breadcrumb);
      } catch (err) {
        this.$sentry({ capture: err });
      }
    },
    searchByName() {
      this.currentPage = 1;
      this.$router.push({
        name: this.$route.name,
        query: {
          pharmacy: this.form.pharmacy,
        },
      });
    },
    searchByCountry() {
      this.currentPage = 1;
      this.$router.push({
        name: this.$route.name,
        query: {
          country: this.form.country,
        },
      });
    },
    pharmacyDetails(pharmacyUuid) {
      this.$router.push({
        name: "pharmacy_sheet",
        params: {
          pharmacyUuid: pharmacyUuid,
        },
      });
    },
    onPageChange() {
      this.loadPharmacies();
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        pharmacies: {
          title: "Pharmacies",
          no_exist: "There are no pharmacies",
          globalstorepharma: "GlobalStorePharma.com",
          description:
            "is the marketplace that groups the largest catalog of pharmacy products and health services. With more than 150 suppliers united in a single platform you can find the product you are looking for at the best price or by availability at only one click.",
          pharmacy_name: "Pharmacy name",
          search: "Search",
          select_country: "Select country",
          see_pharmacies: "See pharmacies",
          see_products: "See products",
          no_results: "No results found",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.pharmacy-name {
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}

.pharmacy-email a {
  color: $text-main-color;
  font-weight: bold;

  &:hover {
    text-decoration: none;
  }
}

.globalstorepharma {
  font-weight: bold;
}

input,
select {
  border-radius: 0;
}

.see-button {
  border-radius: 30px !important;
}
</style>
